import {MinerOffer} from '../InAppOffersService';
import {MinerConfig} from './MinerProposalsState';

export default (_: MinerOffer): MinerConfig => ({
  name: _.poolMinerConfig.name,
  hashrate: _.poolMinerConfig.hash_rate,
  frequency: _.poolMinerConfig.frequency,
});
